import { render } from "./index.vue?vue&type=template&id=f99b5dde"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/design/components/atoms/navigation-item/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f99b5dde"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f99b5dde', __exports__)) {
    api.reload('f99b5dde', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=f99b5dde", () => {
    api.rerender('f99b5dde', render)
  })

}


export default __exports__